const initialState = {
  operationTypeList: null,
};

export default function operationTypeData(state = initialState, action: any) {
  switch (action.type) {
    case "SET_OPERATION_TYPE_LIST":
      const operationTypeList = action.payload;
      return {
        ...state,
        operationTypeList,
      };
    case "REMOVE_OPERATION_TYPE_LIST":
      return { ...initialState };
    default:
      return state;
  }
}
